const features = [
  { label: "Affordable to Ride" },
  { label: "Easy to Use" },
  { label: "Reliable Service" },
];

export default function OverviewSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6 py-10 md:py-14 text-center">
        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-900 mb-6">
          The Airport Shuttle Is Here!
        </h1>
        <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-10 md:mb-12">
          Skip the parking stress and start your trip on the right foot. Southern Transit offers a reliable, 7-day-a-week airport shuttle connecting regional airports with key stops throughout the Trinidad area.
        </p>

        {/* Desktop: 3 columns */}
        <div className="hidden md:grid grid-cols-3 gap-6 mb-10">
          {features.map((f) => (
            <div key={f.label} className="flex items-center justify-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shrink-0">
                <i className="fas fa-check text-sm" />
              </span>
              <h5 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900">
                {f.label}
              </h5>
            </div>
          ))}
        </div>

        {/* Mobile: stacked list */}
        <div className="md:hidden space-y-4 mb-10">
          {features.map((f) => (
            <div key={f.label} className="flex items-center justify-center gap-3">
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shrink-0">
                <i className="fas fa-check text-xs" />
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-900">
                {f.label}
              </span>
            </div>
          ))}
        </div>

        <p className="text-base md:text-lg text-foreground-700 leading-relaxed font-medium">
          Do these times not work for your flight? No problem! You can still get to the airport by transferring from our Main Route. Just let your driver know as soon as you board.
        </p>
      </div>
    </section>
  );
}